module.exports = __webpack_public_path__ + "img/img_t5@2x.c94ecc58.png";